import styles from './MainFormTemplate.module.css'
import {ReactNode} from "react";

interface MainFormTemplatePropsInt
{
    children: ReactNode| undefined
    maxWidth?:string
    title?: string
    background?:string
    onClose?:()=>void
}
export default function MainFormTemplate({children,maxWidth,title,background,onClose}:MainFormTemplatePropsInt)
{
    return(
        <div className={styles.frCont} style={{maxWidth: maxWidth ? maxWidth: "100%", background: background ? background : "transparent"}}>
            { onClose && <div   onClick={()=>onClose()} className={styles.xClose}>Закрыть</div>}
            <form>
                <div className={"row"}>
                    <div className={"col-12 mb-1"}>
                        <div>{title}</div>

                    </div>
                </div>
                {children}
            </form>
        </div>
    )
}